import React, { Component } from 'react';
import * as $ from 'jquery';
import moment from 'moment-timezone';
import spinner from '../../../images/loading-spinner.gif';
import { translate } from 'react-i18next';
import brandLogo from '../../../images/brand-logo-inverse-light.png';


class RoomSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        $('#date').datepicker({
            onSelect: (d, i) => {
                if (d !== i.lastVal) {
                    this.props.handleDateChange(d);
                }
            }
        });
        //$('#btnCOVIDMessage').click();
    }

    isSearchEnabled = () => {
        return !this.props.isSearching
            && this.props.center
            && this.props.date
            && this.props.time
            && moment(this.props.date + " " + this.props.time, 'MM/DD/YYYY HH:mm') > moment()
            && this.props.duration;
    }

    renderCenter = (center, index) => {
        return (
            <li key={index}>
                <a onClick={() => this.props.handleCenterClick(center)}>
                    {center.name}
                </a>
            </li>
        );
    }

    render() {
        const { t } = this.props;
        const center = this.props.center;
        var today = new Date();
        const min_date = moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD')
        const new_date = moment(this.props.date, 'MM/DD/YYYY').format('YYYY-MM-DD')
        return (
            <div className="jumbotron panel-search-resvations">
                <div className="row">
                    <div className="col-md-6">
                        <form method="post" onSubmit={this.props.handleRoomSearch}>
                            <fieldset>
                                <div className="form-group">
                                    <label htmlFor="center">
                                        {t('dashboard.reservations.label_center')}
                                    </label>
                                    <div id="dropdown-div" className="dropdown">
                                        <input
                                            autoComplete="off"
                                            className="dropdown-toggle form-control"
                                            data-toggle="dropdown"
                                            id="center"
                                            onChange={this.props.handleCenterSearch}
                                            onClick={() => { $("#dropdown-div").addClass("open") }}
                                            placeholder={t('dashboard.reservations.holder_center')}
                                            required
                                            type="search"
                                            value={this.props.centerQuery ? this.props.centerQuery : ''} />
                                        <ul id="center-results" className="dropdown-menu" style={{ display: 'none' }}>
                                            {this.props.centers.map((center, index) => this.renderCenter(center, index))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="date">
                                        {t('dashboard.reservations.label_date')}
                                    </label>
                                    <input
                                        autoComplete="off"
                                        className="form-control"
                                        onChange={(e) => this.props.handleDateChange(e.target.value)}
                                        placeholder={t('dashboard.reservations.holder_date')}
                                        required
                                        type="date"
                                        min={min_date}
                                        value={new_date} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="time">
                                        {t('dashboard.reservations.label_time')}
                                    </label>
                                    <select
                                        className="form-control"
                                        id="time"
                                        onChange={this.props.handleTimeChange}
                                        required
                                        value={this.props.time}>
                                        <option>08:00</option>
                                        <option>08:30</option>
                                        <option>09:00</option>
                                        <option>09:30</option>
                                        <option>10:00</option>
                                        <option>10:30</option>
                                        <option>11:00</option>
                                        <option>11:30</option>
                                        <option>12:00</option>
                                        <option>12:30</option>
                                        <option>13:00</option>
                                        <option>13:30</option>
                                        <option>14:00</option>
                                        <option>14:30</option>
                                        <option>15:00</option>
                                        <option>15:30</option>
                                        <option>16:00</option>
                                        <option>16:30</option>
                                        <option>17:00</option>
                                        <option>17:30</option>
                                        <option>18:00</option>
                                        <option>18:30</option>
                                        <option>19:00</option>
                                        <option>19:30</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="duration">
                                        {t('dashboard.reservations.label_duration')}
                                    </label>
                                    <select
                                        className="form-control"
                                        id="duration"
                                        onChange={this.props.handleDurationChange}
                                        required
                                        value={this.props.duration}>
                                        <option value={'4'}>{'2 HORAS'}</option>
                                        <option value={'8'}>{'4 HORAS'}</option>
                                        <option value={'9'}>{'8 HORAS'}</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <button
                                        className="btn btn-primary btn-search-resvations"
                                        type="submit">
                                        {t('dashboard.reservations.btn_search')}
                                    </button>
                                    <div className={this.props.isSearching ? "demo-container" : "hidden"}>
                                        <div className="progress-bar">
                                            <div className="progress-bar-value"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className={this.props.error ? "" : "hidden"}>
                                    <div className="form-group">
                                        <div className="alert alert-warning">
                                            {this.props.error}
                                            <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                    <div className="col-md-6">
                        <div className="iframe-wrapper">
                            <iframe
                                frameBorder="0"
                                src={
                                    "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                                    + (center ? center.latitude : "0")
                                    + "%2C"
                                    + (center ? center.longitude : "0")
                                }
                                title={t('dashboard.reservations.frame_center')}>
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default translate('common')(RoomSearch);


// WEBPACK FOOTER //
// ./src/dashboard/store/Reservation/RoomSearch.js